import {API_BASE_URL} from '../config/apiConfig';
import type {Bank} from '../types/contract';

interface BanksResult {
    success: boolean;
    banks?: Bank[];
    error?: string;
}

export const getBanks = async (token: string): Promise<BanksResult> => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/banks`, {
            method: 'GET',
            headers: {'Content-Type': 'application/json', Authorization: `Bearer ${token}`},
        });
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            return {success: false, error: errorData.message || 'Failed to fetch banks'};
        }
        return {success: true, banks: await response.json()};
    } catch (error) {
        return {success: false, error: error instanceof Error ? error.message : 'Failed to fetch banks'};
    }
};
